import { create } from 'zustand';
import { makeRequest } from "../utils/axios.js"; 

export const useUserDatabase = create((set) => ({
    currentUser: null,
    isLoading: true,

    fetchCurrentUser: async () => {
        set({ isLoading: true });
        
        try {
            const res = await makeRequest.get("/users/me");
            set({ currentUser: res.data, isLoading: false });
        } catch (err) {
            console.log(err);
            set({ currentUser: null, isLoading: false });
        }
    },

    setCurrentUser: (user) => {
        set({ currentUser: user });
    },

    logoutUser: async () => {
        set({ isLoading: true });

        try {
            await makeRequest.post("/auth/logout");
            set({ currentUser: null, isLoading: false });
        } catch (err) {
            console.log(err);
            set({ currentUser: null, isLoading: false });
        }
    }
}));